import { Segment } from 'semantic-ui-react';

const TablePlaceholder = () => {
  return (
    <div className="margin-10 width-55">
      <Segment.Group size='small'>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
        <Segment>
          <div className="ui fluid placeholder">
            <div className="image header">
              <div className="line"></div>
              <div className="line"></div>
            </div>
          </div>
        </Segment>
      </Segment.Group>
    </div>
  )
}

export default TablePlaceholder;